var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LayoutFull"},[_c(_vm.header,{tag:"component"}),_c(_vm.sidebar,{tag:"component"}),_c('div',{staticClass:"LayoutFull-mainContainer",class:{ 'is-close': _vm.closeSidebar }},[_c('b-breadcrumb',{staticClass:"LayoutFull-Breadcrumb",attrs:{"items":_vm.breadcrumb}}),_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }